// extracted by mini-css-extract-plugin
export default {"container":"ShoppingCartContainer_container__hY-rB","content":"ShoppingCartContainer_content__yijDF"};